<template>
  <article class="component-landing-subscription">
    <!-- Enter phone number -->
    <section v-if="requestStatus == SubscriptionUIState.InputPhoneNumber">
      <h3
        v-if="!configurations.enterPhoneNumberMessage.startsWith('<')"
      >
        {{ configurations.enterPhoneNumberMessage }}
      </h3>
      <pre
        v-if="configurations.enterPhoneNumberMessage.startsWith('<')"
        v-html="configurations.enterPhoneNumberMessage"
      />

      <div id="phone" ref="cellNumberWrapper" class="input_container animated">
        <div class="input-prepend">
          <svg
            id="Capa_1"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            width="35px"
            height="35px"
            viewBox="0 0 35 35"
            style="enable-background:new 0 0 35 35;"
            xml:space="preserve"
          >
            <g>
              <path
                d="M25.302,0H9.698c-1.3,0-2.364,1.063-2.364,2.364v30.271C7.334,33.936,8.398,35,9.698,35h15.604
                    c1.3,0,2.364-1.062,2.364-2.364V2.364C27.666,1.063,26.602,0,25.302,0z M15.004,1.704h4.992c0.158,0,0.286,0.128,0.286,0.287
                    c0,0.158-0.128,0.286-0.286,0.286h-4.992c-0.158,0-0.286-0.128-0.286-0.286C14.718,1.832,14.846,1.704,15.004,1.704z M17.5,33.818
                    c-0.653,0-1.182-0.529-1.182-1.183s0.529-1.182,1.182-1.182s1.182,0.528,1.182,1.182S18.153,33.818,17.5,33.818z M26.021,30.625
                    H8.979V3.749h17.042V30.625z"
              />
            </g>
          </svg>
        </div>
        <input
          ref="cellNo"
          v-model="phoneNumber"
          :placeholder="configurations.phoneNumberPlaceholder"
          pattern="[0-9]"
          name="phoneNumber"
          type="tel"
          maxlength="12"
          @input="checkPhoneNumberLength"
        >
      </div>

      <p v-show="showPhoneNumberError" class="alert mt-2">
        {{ configurations.invalidPhoneNumberMessage }}
      </p>

      <div
        v-if="!configurations.headerText.startsWith('<')"
        class="info"
      >
        {{ configurations.headerText }}
      </div>

      <pre v-if="configurations.headerText.startsWith('<')" v-html="configurations.headerText" />

      <button
        ref="register"
        class="button register"
        :class="configurations.subscribtionButtonType + ' ' + configurations.subscribtionButtonAccent"
        @click="initSubscription"
      >
        <span>{{ configurations.subscribeButtonText }}</span>
      </button>
      <div class="footer">
        <span
          v-if="!configurations.termsAndConditions.startsWith('<')"
        >
          {{ configurations.termsAndConditions }}
        </span>
        <pre
          v-if="configurations.termsAndConditions.startsWith('<')"
          v-html="configurations.termsAndConditions"
        />
      </div>
    </section>

    <!-- confirm phone number -->
    <section v-if="requestStatus == SubscriptionUIState.InputConfirmationCode">
      <div class="mt-5">
        <span v-if="!configurations.enterConfirmationCodeMessage.startsWith('<')">
          {{ configurations.enterConfirmationCodeMessage }}
        </span>
        <pre v-if="configurations.enterConfirmationCodeMessage.startsWith('<')" v-html="configurations.enterConfirmationCodeMessage" />
      </div>

      <button
        class="button"
        :class="configurations.subscribtionButtonType + ' ' + configurations.subscribtionButtonAccent"
      >
        <a :href="sendSMS()">
          {{ configurations.verifyButtonText }}
        </a>
      </button>
    </section>

    <!-- Footer -->
    <section>
      <div class="mt-3">
        <span v-if="!configurations.footerText.startsWith('<')">
          {{ configurations.footerText }}
        </span>
        <pre v-if="configurations.footerText.startsWith('<')" v-html="configurations.footerText" />
      </div>
      <a
        class="conditions"
        :href="configurations.rulesUrl"
        target="_blank"
      >
        {{ configurations.rulesText }}
      </a>
    </section>
  </article>
</template>

<script>
import Vue from 'vue'
import utility from '@/utilities/utility'

export default Vue.extend({
  name: 'SectionWithoutSubscription',
  props: {
    configurations: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      requestStatus: '',
      phoneNumber: '',
      number: '',
      messageText: '',
      showPhoneNumberError: false,
      SubscriptionUIState: {
        InputPhoneNumber: 1,
        InputConfirmationCode: 2
      }
    }
  },

  mounted () {
    let userUniqueIdentifier = utility.getQueryStringValue(
      'useruniqueidentifier'
    )
    if (!userUniqueIdentifier) return

    this.phoneNumber = userUniqueIdentifier
  },
  created () {
    this.requestStatus = this.SubscriptionUIState.InputPhoneNumber
    this.number = this.configurations.number
    this.messageText = this.configurations.messageText
  },
  methods: {
    checkPhoneNumberLength () {
      this.showPhoneNumberError = false

      let registerButton = this.$refs.register
      var element = this.$refs.cellNo
      var length = element.value.length
      let buttonColor = registerButton.classList.contains('green')
        ? '153, 204, 102'
        : '82, 170, 204'
      registerButton.style =
        'background: rgba(' +
        buttonColor +
        ',' +
        (length + 2) / 10 +
        '); border: inset 5px rgba(255, 255, 255,' +
        (length + 2) / 10 +
        ')'

      if (length > this.configurations.numberOfDigits) {
        registerButton.classList.add('shadow')
      } else {
        registerButton.classList.remove('shadow')
      }
    },
    initSubscription () {
      let element = this.$refs.cellNo
      let length = element.value.length

      if (length < this.configurations.numberOfDigits) {
        this.showPhoneNumberError = true

        let inputWrapper = this.$refs.cellNumberWrapper
        inputWrapper.classList.add('tada')
        setTimeout(() => {
          inputWrapper.classList.remove('tada')
        }, 1000)
      } else {
        this.showPhoneNumberError = false
        this.requestStatus = this.SubscriptionUIState.InputConfirmationCode
      }
    },
    sendSMS () {
      let sendSms = `sms:${this.configurations.number}?body=${this.configurations.messageText}`
      return sendSms
    }
  }
})
</script>
